<template>
   
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/administration">{{lang.LBL_ADMIN}}</router-link></li>
        <li><router-link to="/modules/emails/edit">{{lang.LBL_ADD_EMAILS}}</router-link></li>
        <li><router-link to="/modules/emails">{{lang.LBL_VIEW_EMAILS}}</router-link></li>
    </ul>
           

</template>
<script>
import lang from "@/views/modules/Emails/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
        }
     },
     mounted() {
        this.lang = lang;
    },
     
}
</script>
